import { useNavigate } from "react-router-dom";

import styles from './TeamCard.module.css';
import robocup_img from '@shared/assets/robocup.jpeg';



const teamLogos = import.meta.glob('../../assets/logos/*.png', { 
        eager: true, 
        import: 'default' 
    });

export const TeamIcon = (id) => {
        const imagePath = `../../assets/logos/${id}.png`;
        const imageSrc = teamLogos[imagePath];

        if (!imageSrc) {
            console.warn(`Image not found for: ${imagePath}`);
            return robocup_img;
        }
        return imageSrc
    };

export const TeamCard = ({ team, game_count }) => {
    const navigate = useNavigate();

    return (
        <div className={styles.event_card}>
            <div className={styles.event_header} onClick={() => navigate(`/team/${team.id}`)}>
                <img src={TeamIcon(team.team_id)} alt={`logo of team :${team.name} `} />
            </div>
            <div className={styles.event_content}>
                <p className={styles.event_title}>
                    {team.name} - {team.team_id}
                </p>
                 <h3> {game_count} games</h3>
            </div>
        </div>
    );
};